import { ContextType } from './flags.const';
export const getContext = (kind = ContextType.USER, options) => {
    return {
        kind,
        anonymous: true,
        key: 'abcd1234',
    };
};
//# sourceMappingURL=launchdarkly.util.js.map